var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready),expression:"ready"}],ref:"totalWeek",attrs:{"id":"totalWeek","width":"400","height":"400"}})
}
var staticRenderFns = []

export { render, staticRenderFns }